import type {
    PackageBookingItemMeta,
    SelectedProductOption,
} from '@/views/availability/components/PackageBookingSideform/package-form.helpers';
import type { PackageSelectedProductOptionCard } from '@/views/availability/components/PackageBookingSideform/components/PackageProductOptions/PackageProductAddOptionsDialog';

export const toProductOptionCard = (
    itemKey: string,
    selectedProductOption: SelectedProductOption,
    availableProductByKey: Record<string, PackageBookingItemMeta>
): PackageSelectedProductOptionCard | null => {
    const availableProduct = availableProductByKey[itemKey];
    if (!availableProduct) return null;

    const selectedProductOptionMeta = availableProduct.optionsCatalog.find(
        (productOption) => productOption.id === selectedProductOption.optionId
    );

    return {
        id: `${itemKey}:${selectedProductOption.optionId}`,
        itemKey,
        optionId: selectedProductOption.optionId,
        productName: availableProduct.product.name,
        productOptionType: selectedProductOptionMeta?.type,
        productOptionName:
            selectedProductOptionMeta?.name || selectedProductOption.optionId,
        pricing: selectedProductOptionMeta?.pricing,
        pax: selectedProductOption.pax,
    };
};
